export function formatMetricBucketLabel(bucket: string, hours: number, locale: string) {
  const date = new Date(bucket);

  return hours <= 24
    ? date.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit', hour12: false })
    : date.toLocaleString(locale, {
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      });
}
